import { useCallback, useRef, useState } from 'react';
import type { RowSelectedEvent } from 'ag-grid-community';

export const useArchiveSelection = <T extends { uuid: string }>() => {
  const selectedRowsMap = useRef<Map<string, T>>(new Map());
  const [selectedCount, setSelectedCount] = useState(0);

  const onRowSelected = useCallback((event: RowSelectedEvent<T>) => {
    if (!event.data) return;
    if (event.node.isSelected()) {
      selectedRowsMap.current.set(event.data.uuid, event.data);
    } else {
      selectedRowsMap.current.delete(event.data.uuid);
    }
    setSelectedCount(selectedRowsMap.current.size);
  }, []);

  const getSelectedRows = useCallback(() => Array.from(selectedRowsMap.current.values()), []);

  return { selectedCount, onRowSelected, getSelectedRows };
};
